import Layout from '../../internal/LayoutWithoutContainer.vue'
import DashboardPage from './index.vue'

const DashboardRoutes = {
  component: Layout,
  children: [
    {
      name: 'dash',
      path: '/',
      component: DashboardPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default DashboardRoutes
